import { useTranslation } from 'react-i18next';

type ThankYouMessageProps = {
  email?: string;
};

export const ThankYouMessage = ({ email }: ThankYouMessageProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <h1 className="text-2xl font-extrabold leading-8 text-gray-900">{t('orderForms:success.thankYou')}</h1>
      <p className="text-base leading-6 text-gray-500">
        {t('orderForms:success.confirmationEmail')} <span className="font-medium text-gray-700">{email}</span>
      </p>
    </div>
  );
};
